import React, { useState, useEffect } from 'react';
import { array, func, bool, string } from 'prop-types';
import {Collapse} from 'react-bootstrap';
import { CloneObject } from '../../../utils/helpers';
import { useLocation } from 'react-router-dom';

import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import './index.scss';

function AdvancedSearch(props) {

    const location = useLocation();
    const isFirstRender = React.useRef(true);

    //hooks
    const [state, setState] = useState({
        showFilters: props.initShowFilters,
        labels: []
    });

    const [onSearch, setOnSearch] = useState(false)
    const [requireMessage, setRequireMessage] = useState(null)
    const message = requireMessage ?? props.message

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;
            return;
        }
        
        setState(prevState => {
            return {...prevState,
                showFilters: true
            };
        });
    }, [location]);

    useEffect(() => {
        setState(prevState => {
            return {...prevState, labels: props.labels};
        });
    }, [props.labels]);

    useEffect(() => {
        setState(prevState => {
            return {...prevState, showFilters: props.initShowFilters};
        });
    }, [props.initShowFilters]);

    useEffect(() => {
        if (onSearch){
            search(true);
            setOnSearch(false)
            setState(prevState => {
                return {...prevState, showFilters: true};
            });
        }
    }, [props.formValues]);
  

    useEffect(() => {
        if (message) {
            setState(prevState => {
                return {...prevState, showFilters: true};
            });
        }
    }, [message]);

    const handleClick = (label) => {

        setOnSearch(true)

        let newFormValues = CloneObject(props.formValues)

        if (label.fieldOriginal){
            newFormValues[label.fieldOriginal] = label.valueIgnoreOriginal // label.valueIgnore
            newFormValues[label.field] = label.valueIgnore
            props.formSet(newFormValues)
        }
        else{
            newFormValues[label.field] = label.valueIgnore
            props.formSet(newFormValues)
        }
    }

    const handleClickBuscar = () => {
        if (isFormValid()){
            search()
        }       
    }

    const isFormValid = () => {
        if (props.requireFilter && !props.hasActiveFilters) {
            setRequireMessage(VALIDATION_MESSAGE.REQUIRE_FILTER);
            return false
        }

        setRequireMessage(null);
        return true
    }

    const search = (keepOpen = false) => {
        let valid = true;
        if (props.onValidation) {
            valid = props.onValidation();
        }
        if (!valid) return;

        const result = props.onSearch();
        if (result && typeof result.then === 'function') {
            if (!keepOpen) {
                result.then((hasResults) => {
                    if (hasResults !== false) CollapseFilters();
                });
            }
        }
        else {
            ToggleFilters();
        }
    }

    function CollapseFilters() {
        setState(prevState => {
            return {...prevState, showFilters: false};
        });
    }

    function ToggleFilters() {
        setState(prevState => {
            return {...prevState, showFilters: !prevState.showFilters};
        });
    }
   
    const accordionClose = <span className="material-symbols-outlined search-i">chevron_right</span>
    const accordionOpen = <span className="material-symbols-outlined search-i">expand_more</span>

    return (
    <>

            <div className='busqueda-avanzada'>
                <div className="col-12">
                    <div className='accordion-header'>
                        <div className='row'>
                            <div className="col-12" onClick={() => ToggleFilters()}>
                                <div className='accordion-header-title'>
                                    {(state.showFilters) ? accordionOpen : accordionClose}
                                    <span className={state.showFilters ? 'active' : ''}>Búsqueda</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Collapse  in={state.showFilters}>
                    <div className='accordion-body '>
                        <div className='row'>
                            <div className="col-12">
                                {props.children}
                            </div>
                        </div>
                        <div className='row'>
                            <div className="col-12 m-top-10 d-flex align-items-center gap-2">
                                {message && (
                                    <span className="busqueda-mensaje">
                                        <span className="material-symbols-outlined" aria-hidden="true">warning</span>
                                        {message}
                                    </span>
                                )}
                                <button className="btn btn-busqueda ms-auto" onClick={ (event) => handleClickBuscar() }>{props.textButton}</button>
                            </div>
                        </div>
                    </div>
                    </Collapse >
                    <div className='marcador-body'>
                        <div className='row'>
                            {state.labels.map((label, index) =>
                                <div className="marcador" key={index}>
                                    <span>{label.title}:&nbsp;
                                        <strong>{label.value?.toString()}
                                        {(props.formValues && props.formSet) &&
                                        <a href='#' className="link-no-color">
                                            <span onClick={ () => handleClick(label) } className="material-symbols-outlined span-close">close</span>
                                        </a>
                                        }
                                        </strong>
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        
    </>
    )
}

AdvancedSearch.propTypes = {
    initShowFilters: bool,
    requireFilter: bool,
    hasActiveFilters: bool,
    onValidation: func,
    onSearch: func.isRequired,
    labels: array.isRequired,
    textButton: string,
    message: string,
};

AdvancedSearch.defaultProps = {
    requireFilter: false,
    hasActiveFilters: false,
    onValidation: null,
    initShowFilters: true,
    textButton: "Buscar"
}


export default AdvancedSearch;
